if (!window.mtScriptsInicializado) {
  window.mtScriptsInicializado = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initContador();
    initGaleriaProducto();
    initVariantes();
    initComparador();
    initCalculadoraTalla();
    initBarraFija();
    initVideosTestimonio();
    initLineaTiempo();
    initGiro360();
    initDescripcionInteractiva();
    initAddonCarrito();
    initSelectorCantidad();
    initFaqAbrir();
    initUsoInteractivo();
    initTemasContacto();
  });
}

/* Reveals al hacer scroll (un único observer compartido) */
function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

/* Cifras animadas (count-up) al entrar en pantalla */
function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
      var dur = 1400;
      var t0 = performance.now();
      function paso(t) {
        var p = Math.min(1, (t - t0) / dur);
        var ease = 1 - Math.pow(1 - p, 3);
        var val = fin * ease;
        el.textContent = (fin % 1 === 0) ? Math.round(val) : val.toFixed(1);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

/* Galería de la página de producto: miniatura -> imagen principal */
function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-galeria-principal]');
  var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.style.opacity = '0';
      window.setTimeout(function () {
        principal.src = full;
        principal.alt = alt;
        principal.style.opacity = '1';
      }, 150);
      minis.forEach(function (m) { m.classList.remove('is-activa'); });
      mini.classList.add('is-activa');
    });
  });
}

/* Comparador antes/después con deslizador arrastrable */
function initComparador() {
  var comparadores = document.querySelectorAll('[data-mt-comparador]');
  comparadores.forEach(function (comp) {
    var range = comp.querySelector('[data-mt-comparador-range]');
    var marco = comp.querySelector('.mt-comparador__marco');
    if (!range || !marco) return;

    function fijarPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      comp.style.setProperty('--mt-pos', pct + '%');
      range.value = pct;
    }

    range.addEventListener('input', function () {
      fijarPos(parseFloat(range.value));
    });

    function pctDesdeEvento(clientX) {
      var rect = marco.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    var arrastrando = false;
    function onMove(e) {
      if (!arrastrando) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      fijarPos(pctDesdeEvento(clientX));
    }
    marco.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      fijarPos(pctDesdeEvento(e.clientX));
      marco.setPointerCapture && marco.setPointerCapture(e.pointerId);
    });
    marco.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', function () { arrastrando = false; });
  });
}

/* Selector de variantes de producto */
function initVariantes() {
  var forms = document.querySelectorAll('[data-mt-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var scope = form.closest('.mt-producto__compra') || form;
    var selects = form.querySelectorAll('[data-mt-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = scope.querySelector('[data-mt-precio]');
    var precioCompareEl = scope.querySelector('[data-mt-precio-compare]');
    var botonEl = form.querySelector('[data-mt-add]');
    var textoBoton = botonEl ? botonEl.getAttribute('data-texto-comprar') : '';
    var textoAgotado = botonEl ? botonEl.getAttribute('data-texto-agotado') : '';
    var precioStickyEl = document.querySelector('[data-mt-sticky-precio]');
    var botonStickyEl = document.querySelector('[data-mt-sticky-boton]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      if (!selects.length) return;
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      if (idInput) idInput.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = moneda(variante.compare_at_price);
          precioCompareEl.hidden = false;
        } else {
          precioCompareEl.hidden = true;
        }
      }
      if (botonEl) {
        botonEl.disabled = !variante.available;
        var botonTextoEl = botonEl.querySelector('[data-mt-boton-texto]');
        if (botonTextoEl) botonTextoEl.textContent = variante.available ? textoBoton : textoAgotado;
        else botonEl.textContent = variante.available ? textoBoton : textoAgotado;
        var botonPrecioEl = botonEl.querySelector('[data-mt-precio-boton]');
        if (botonPrecioEl) botonPrecioEl.textContent = moneda(variante.price);
      }
      if (precioStickyEl) precioStickyEl.textContent = moneda(variante.price);
      if (botonStickyEl) {
        botonStickyEl.disabled = !variante.available;
        botonStickyEl.textContent = variante.available ? textoBoton : textoAgotado;
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

/* Barra de compra fija en móvil: aparece al pasar el bloque de compra principal */
function initBarraFija() {
  var barra = document.querySelector('[data-mt-sticky]');
  var botonPrincipal = document.querySelector('[data-mt-add]');
  if (!barra || !botonPrincipal) return;

  var botonSticky = barra.querySelector('[data-mt-sticky-boton]');
  if (botonSticky) {
    botonSticky.addEventListener('click', function () {
      botonPrincipal.click();
    });
  }

  barra.hidden = false;
  var footer = document.querySelector('footer');
  var pasadoElBoton = false;
  var enFooter = false;

  function actualizarVisibilidad() {
    barra.classList.toggle('is-visible', pasadoElBoton && !enFooter);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      pasadoElBoton = !entries[0].isIntersecting;
      actualizarVisibilidad();
    }, { threshold: 0 }).observe(botonPrincipal);

    if (footer) {
      new IntersectionObserver(function (entries) {
        enFooter = entries[0].isIntersecting;
        actualizarVisibilidad();
      }, { threshold: 0, rootMargin: '0px' }).observe(footer);
    }
  }
}

/* Calculadora de talla por ancho de pata o raza */
function initCalculadoraTalla() {
  var calculadoras = document.querySelectorAll('[data-mt-calculadora]');
  calculadoras.forEach(function (calc) {
    var toggle = calc.querySelector('[data-mt-calculadora-toggle]');
    var panel = calc.querySelector('[data-mt-calculadora-panel]');
    var rango = calc.querySelector('[data-mt-calculadora-rango]');
    var valorEl = calc.querySelector('[data-mt-calculadora-valor]');
    var tallaEl = calc.querySelector('[data-mt-calculadora-talla]');
    var razas = calc.querySelectorAll('[data-mt-calculadora-raza]');
    var botonUsar = calc.querySelector('[data-mt-calculadora-usar]');
    if (!panel || !rango || !tallaEl) return;

    var umbrales = {
      XS: parseFloat(calc.getAttribute('data-umbral-xs')) || 3.8,
      S: parseFloat(calc.getAttribute('data-umbral-s')) || 4.6,
      M: parseFloat(calc.getAttribute('data-umbral-m')) || 5.4,
      L: parseFloat(calc.getAttribute('data-umbral-l')) || 6.2
    };

    function tallaParaAncho(cm) {
      if (cm <= umbrales.XS) return 'XS';
      if (cm <= umbrales.S) return 'S';
      if (cm <= umbrales.M) return 'M';
      if (cm <= umbrales.L) return 'L';
      return 'XL';
    }

    function actualizarResultado() {
      var cm = parseFloat(rango.value);
      if (valorEl) valorEl.textContent = cm.toFixed(1);
      var talla = tallaParaAncho(cm);
      tallaEl.textContent = talla;
      tallaEl.classList.remove('mt-pulso');
      void tallaEl.offsetWidth;
      tallaEl.classList.add('mt-pulso');
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var abierto = !panel.hidden;
        panel.hidden = abierto;
        toggle.setAttribute('aria-expanded', String(!abierto));
      });
    }

    rango.addEventListener('input', function () {
      razas.forEach(function (r) { r.classList.remove('is-activa'); });
      actualizarResultado();
    });

    razas.forEach(function (boton) {
      boton.addEventListener('click', function () {
        var ancho = parseFloat(boton.getAttribute('data-ancho'));
        if (isNaN(ancho)) return;
        rango.value = ancho;
        razas.forEach(function (r) { r.classList.remove('is-activa'); });
        boton.classList.add('is-activa');
        actualizarResultado();
      });
    });

    if (botonUsar) {
      botonUsar.addEventListener('click', function () {
        var talla = tallaEl.textContent.trim();
        var form = calc.closest('form');
        if (!form) return;
        var selects = form.querySelectorAll('[data-mt-opcion]');
        var destino = Array.prototype.find.call(selects, function (s) {
          return Array.prototype.some.call(s.options, function (o) { return o.value === talla; });
        });
        if (!destino) return;
        destino.value = talla;
        destino.dispatchEvent(new Event('change', { bubbles: true }));
        var boton = form.querySelector('[data-mt-add]');
        if (boton) {
          boton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    actualizarResultado();
  });
}

/* Línea de tiempo interactiva (compra -> envío -> entrega -> devolución) */
function initLineaTiempo() {
  var lineas = document.querySelectorAll('[data-mt-linea]');
  lineas.forEach(function (linea) {
    var total = parseInt(linea.getAttribute('data-mt-linea-total'), 10) || 1;
    var progreso = linea.querySelector('[data-mt-linea-progreso]');
    var furgoneta = linea.querySelector('[data-mt-linea-furgoneta]');
    var pasos = linea.querySelectorAll('[data-mt-linea-paso]');
    if (!progreso || !furgoneta || !pasos.length) return;

    function irAPaso(indice) {
      var pct = total > 1 ? (indice / (total - 1)) * 100 : 0;
      progreso.style.width = pct + '%';
      furgoneta.style.left = pct + '%';
      pasos.forEach(function (p) {
        p.classList.toggle('is-activo', parseInt(p.getAttribute('data-indice'), 10) === indice);
      });
    }

    pasos.forEach(function (paso) {
      paso.addEventListener('click', function () {
        irAPaso(parseInt(paso.getAttribute('data-indice'), 10));
      });
    });

    irAPaso(0);

    if ('IntersectionObserver' in window) {
      var reproducido = false;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || reproducido) return;
          reproducido = true;
          obs.unobserve(linea);
          var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (sinMovimiento) {
            irAPaso(total - 1);
            return;
          }
          for (var i = 1; i < total; i++) {
            (function (indice) {
              setTimeout(function () { irAPaso(indice); }, indice * 550);
            })(i);
          }
        });
      }, { threshold: 0.4 });
      obs.observe(linea);
    }
  });
}

/* Vídeos testimonio: clic para reproducir, pausa el resto */
function initVideosTestimonio() {
  var tarjetas = document.querySelectorAll('[data-mt-videocard]');
  if (!tarjetas.length) return;
  tarjetas.forEach(function (tarjeta) {
    var video = tarjeta.querySelector('[data-mt-videocard-el]');
    var boton = tarjeta.querySelector('[data-mt-videocard-play]');
    if (!video || !boton) return;

    function reproducir() {
      tarjetas.forEach(function (otra) {
        if (otra === tarjeta) return;
        var otroVideo = otra.querySelector('[data-mt-videocard-el]');
        if (otroVideo) otroVideo.pause();
        otra.classList.remove('is-reproduciendo');
      });
      tarjeta.classList.add('is-reproduciendo');
      video.play();
    }

    boton.addEventListener('click', reproducir);
    video.addEventListener('click', function () {
      if (video.paused) reproducir();
    });
    video.addEventListener('pause', function () {
      tarjeta.classList.remove('is-reproduciendo');
    });
    video.addEventListener('ended', function () {
      tarjeta.classList.remove('is-reproduciendo');
    });
  });
}

/* Visor 360: arrastra para girar entre las fotos del producto */
function initGiro360() {
  var giros = document.querySelectorAll('[data-mt-giro]');
  giros.forEach(function (giro) {
    var frames = Array.prototype.slice.call(giro.querySelectorAll('[data-mt-giro-frame]'));
    var puntos = Array.prototype.slice.call(giro.querySelectorAll('[data-mt-giro-punto]'));
    var btnPrev = giro.querySelector('[data-mt-giro-prev]');
    var btnNext = giro.querySelector('[data-mt-giro-next]');
    if (frames.length < 2) return;

    var indice = 0;
    var arrastrando = false;
    var xInicio = 0;
    var xAcumulado = 0;
    var PASO_PX = 45;

    function mostrar(nuevoIndice) {
      indice = ((nuevoIndice % frames.length) + frames.length) % frames.length;
      frames.forEach(function (f, i) { f.classList.toggle('is-activa', i === indice); });
      puntos.forEach(function (p, i) { p.classList.toggle('is-activa', i === indice); });
    }

    function iniciar(x) {
      arrastrando = true;
      xInicio = x;
      xAcumulado = 0;
      giro.classList.add('is-arrastrando');
    }
    function mover(x) {
      if (!arrastrando) return;
      var delta = x - xInicio;
      xAcumulado += delta;
      xInicio = x;
      while (xAcumulado > PASO_PX) { mostrar(indice - 1); xAcumulado -= PASO_PX; }
      while (xAcumulado < -PASO_PX) { mostrar(indice + 1); xAcumulado += PASO_PX; }
    }
    function terminar() {
      arrastrando = false;
      giro.classList.remove('is-arrastrando');
    }

    giro.addEventListener('pointerdown', function (e) {
      iniciar(e.clientX);
      giro.setPointerCapture && giro.setPointerCapture(e.pointerId);
    });
    giro.addEventListener('pointermove', function (e) { mover(e.clientX); });
    giro.addEventListener('pointerup', terminar);
    giro.addEventListener('pointerleave', terminar);
    giro.addEventListener('pointercancel', terminar);

    giro.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { mostrar(indice - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { mostrar(indice + 1); e.preventDefault(); }
    });

    if (btnPrev) btnPrev.addEventListener('click', function () { mostrar(indice - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { mostrar(indice + 1); });
  });
}

/* Descripción del producto: cada punto se resalta al pasar el cursor */
function initDescripcionInteractiva() {
  var descripciones = document.querySelectorAll('[data-mt-descripcion]');
  descripciones.forEach(function (desc) {
    var lista = desc.querySelector('ul');
    if (!lista || !lista.children.length) return;
    lista.classList.add('mt-descripcion__lista');
    Array.prototype.forEach.call(lista.children, function (li, i) {
      li.classList.add('mt-descripcion__item');
      li.style.setProperty('--mt-i', i);
      var icono = document.createElement('span');
      icono.className = 'mt-descripcion__check';
      icono.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg>';
      li.prepend(icono);
    });
  });
}

/* Añadir el pack de filtros junto al producto principal en un solo clic */
function initAddonCarrito() {
  var addons = document.querySelectorAll('[data-mt-addon]');
  addons.forEach(function (addon) {
    var check = addon.querySelector('[data-mt-addon-check]');
    var variantId = addon.getAttribute('data-variant-id');
    var form = addon.closest('.mt-producto__compra') ? addon.closest('.mt-producto__compra').querySelector('[data-mt-producto-form]') : null;
    if (!check || !variantId || !form) return;

    addon.addEventListener('click', function (e) {
      if (e.target === check || check.disabled) return;
      e.preventDefault();
      check.checked = !check.checked;
    });

    form.addEventListener('submit', function (e) {
      var qtyInput = form.querySelector('[data-mt-cantidad-input]');
      var cantidad = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var esRegaloFamiliar = cantidad === 3;
      if (!check.checked && !esRegaloFamiliar) return;
      e.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      var boton = form.querySelector('[data-mt-add]');
      if (!idInput) return;
      if (boton) boton.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: parseInt(idInput.value, 10), quantity: cantidad },
            { id: parseInt(variantId, 10), quantity: 1 }
          ]
        })
      })
        .then(function (res) { if (!res.ok) throw new Error('cart-add-failed'); return res.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          if (boton) boton.disabled = false;
          form.submit();
        });
    });
  });
}

/* Tarjetas de 1 / 2 / 3 unidades: selecciona cantidad y actualiza el precio del botón */
function initSelectorCantidad() {
  var selectores = document.querySelectorAll('[data-mt-cantidad]');
  selectores.forEach(function (selector) {
    var tarjetas = Array.prototype.slice.call(selector.querySelectorAll('[data-mt-cantidad-opcion]'));
    var compra = selector.closest('.mt-producto__compra');
    if (!compra) return;
    var cantidadInput = compra.querySelector('[data-mt-cantidad-input]');
    var precioBoton = compra.querySelector('[data-mt-precio-boton]');
    var addon = compra.querySelector('[data-mt-addon]');
    var addonCheck = addon ? addon.querySelector('[data-mt-addon-check]') : null;
    var addonBadge = addon ? addon.querySelector('.mt-producto__addon-badge') : null;
    var addonTitulo = addon ? addon.querySelector('.mt-producto__addon-texto strong') : null;
    var addonPrecios = addon ? addon.querySelector('.mt-producto__addon-precios') : null;
    if (!cantidadInput) return;

    var original = {
      badge: addonBadge ? addonBadge.textContent : '',
      titulo: addonTitulo ? addonTitulo.textContent : '',
      precios: addonPrecios ? addonPrecios.innerHTML : ''
    };

    function actualizarAddon(qty) {
      if (!addon) return;
      if (qty === '1') {
        addon.hidden = false;
        if (addonCheck) { addonCheck.disabled = false; addonCheck.checked = true; }
        if (addonBadge) addonBadge.textContent = original.badge;
        if (addonTitulo) addonTitulo.textContent = original.titulo;
        if (addonPrecios) addonPrecios.innerHTML = original.precios;
      } else {
        addon.hidden = true;
        if (addonCheck) { addonCheck.checked = false; }
      }
    }

    tarjetas.forEach(function (tarjeta) {
      tarjeta.addEventListener('click', function () {
        tarjetas.forEach(function (t) { t.classList.remove('is-activa'); });
        tarjeta.classList.add('is-activa');
        var qty = tarjeta.getAttribute('data-qty') || '1';
        cantidadInput.value = qty;
        var precio = tarjeta.getAttribute('data-precio');
        if (precioBoton && precio) precioBoton.textContent = precio;
        actualizarAddon(qty);
      });
    });
  });
}

/* FAQ flotante: toca una tarjeta para abrirla (táctil), cierra las demás */
function initFaqAbrir() {
  var items = document.querySelectorAll('.mt-faq__item');
  if (!items.length) return;

  items.forEach(function (item) {
    var tarjeta = item.querySelector('.mt-faq__tarjeta');
    if (!tarjeta) return;
    tarjeta.addEventListener('click', function () {
      var yaAbierta = item.classList.contains('is-abierta');
      items.forEach(function (i) { i.classList.remove('is-abierta'); });
      if (!yaAbierta) item.classList.add('is-abierta');
    });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.mt-faq__item')) return;
    items.forEach(function (i) { i.classList.remove('is-abierta'); });
  });
}

/* Pasos de uso interactivos: pestañas con avance automático y barra de progreso por paso */
function initUsoInteractivo() {
  var contenedores = document.querySelectorAll('[data-mt-uso]');
  contenedores.forEach(function (cont) {
    var panels = Array.prototype.slice.call(cont.querySelectorAll('[data-mt-uso-panel]'));
    var pills = Array.prototype.slice.call(cont.querySelectorAll('[data-mt-uso-pill]'));
    if (!panels.length || !pills.length) return;

    var duracion = parseInt(cont.getAttribute('data-mt-uso-autoplay'), 10) || 5000;
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var indice = 0;
    var temporizador = null;
    var pausado = false;

    function fijar(nuevo) {
      indice = nuevo;
      panels.forEach(function (p, i) { p.classList.toggle('is-activo', i === indice); });
      pills.forEach(function (pill, i) {
        var relleno = pill.querySelector('[data-mt-uso-relleno]');
        pill.classList.toggle('is-activo', i === indice);
        pill.classList.toggle('is-completado', i < indice);
        pill.setAttribute('aria-selected', i === indice ? 'true' : 'false');
        if (!relleno) return;
        if (i === indice) {
          relleno.style.transition = 'none';
          relleno.style.transform = 'scaleX(0)';
          relleno.getBoundingClientRect();
          relleno.style.transition = reducido ? 'none' : 'transform ' + duracion + 'ms linear';
          relleno.style.transform = 'scaleX(1)';
        } else if (i < indice) {
          relleno.style.transition = 'none';
          relleno.style.transform = 'scaleX(1)';
        } else {
          relleno.style.transition = 'none';
          relleno.style.transform = 'scaleX(0)';
        }
      });
    }

    function programar() {
      if (temporizador) clearTimeout(temporizador);
      if (reducido || pausado) return;
      temporizador = setTimeout(function () {
        fijar((indice + 1) % panels.length);
        programar();
      }, duracion);
    }

    pills.forEach(function (pill, i) {
      pill.addEventListener('click', function () {
        fijar(i);
        programar();
      });
    });

    cont.addEventListener('mouseenter', function () {
      pausado = true;
      if (temporizador) clearTimeout(temporizador);
    });
    cont.addEventListener('mouseleave', function () {
      pausado = false;
      programar();
    });

    fijar(0);
    programar();
  });
}

/* Chips de asunto rápido en contacto: rellenan el mensaje del formulario con 1 clic */
function initTemasContacto() {
  var grupos = document.querySelectorAll('[data-mt-temas]');
  if (!grupos.length) return;

  grupos.forEach(function (grupo) {
    var chips = Array.prototype.slice.call(grupo.querySelectorAll('[data-mt-tema]'));
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var textarea = document.getElementById('ContactForm-body');
        if (!textarea) return;

        chips.forEach(function (c) { c.classList.remove('is-activo'); });
        chip.classList.add('is-activo');

        textarea.value = chip.getAttribute('data-mensaje') || '';
        textarea.dispatchEvent(new Event('input', { bubbles: true }));

        textarea.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(function () {
          textarea.focus();
          var final = textarea.value.length;
          if (textarea.setSelectionRange) textarea.setSelectionRange(final, final);
        }, 350);

        chip.classList.remove('is-enviado');
        void chip.offsetWidth;
        chip.classList.add('is-enviado');
      });
    });
  });
}
